module.exports = __webpack_public_path__ + "img/island-table-icon.944a20a2.svg";